// extracted by mini-css-extract-plugin
export default {"heading":"kA-z","corrected":"lA-z","redirectVerbiageContainer":"mA-z","redirectVerbiageText":"nA-z"};